import { Grid } from "@material-ui/core";
import { DatePickerInput } from "rc-datepicker";
import React, { useEffect, useState } from "react";
import Moment from "moment";
import { Tooltip } from "@material-ui/core";
import { Link } from 'react-router-dom';
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../biztran_controls/BiztranControls";
import UseFetchData from "../../hooks/UseFetchData";
import CreateActivities from "./Activities/CreateActivities";
import ModalFrame from "../biztran_controls/Modal_Frame";

const todate = new Date()
const Dfromdate = todate.getFullYear() + '/01/01'
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);


const Activities = (props) => {
    const [isOpen, setOpen] = useState(false);
    const [ActivityID, setActivityID] = useState('');
    const [ContactID, setContactID] = useState('');
    const [ActivityTypeID, setActivityTypeID] = useState('');
    const [EmployeeID, setEmployyeID] = useState('');
    const [UserType, setUserType] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [UserGroupID, setUserGroupID] = useState();
    const [CustID, setCustID] = useState('');
    const [DocumentID, setDocumentID] = useState('');
    const [Category, setCategory] = useState('');
    const [FromDate, setFromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [CustName, setCustName] = useState();
    const [Contactcmb, setContactcmb] = useState([]);
    const [Activitycmb, setActivitycmb] = useState([]);
    const [Employeecmb, setEmployeecmb] = useState([]);
    const [Documentcmb, setDoccmb] = useState([]);
    const [responseContDtls, fetchContDtls] = UseFetchData();
    const [CustOptions, setCustOptions] = useState([]);
    const [responseCust, fetchCustData] = UseFetchData();
    const [responseType, fetchTypeData] = UseFetchData();
    const [responseDoc, fetchDocData] = UseFetchData();
    const [responseEmployee, fetchEmployeeData] = UseFetchData();
    const [Typecmb, setTypecmb] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [SearchMode, setSearchMode] = useState("SEARCH");
    const [response, fetchData] = UseFetchData();
    const [Count, setCount] = useState();

    const getContactDtls = (CID) => {
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("AccountID", CID);
        fetchContDtls("Activity/ComboDataAct", bodyFormData);
    }

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const CustData = () => {
        var bodyFormData = new FormData();
        fetchCustData("Activity/ComboDataAct", bodyFormData);
    }
    const CategoryOption = [
        { id: "Lead", title: "Lead" },
        { id: "Opportunity", title: "Opportunity" },
        { id: "Quotation", title: "Quotation" },
        { id: "SalesOrder", title: "SalesOrder" },
    ];
    const TypeData = () => {
        var bodyFormData = new FormData();
        fetchTypeData("Activity/ComboDataAct", bodyFormData);
    }
    const DocType = (Cat) => {
        var bodyFormData = new FormData();
        bodyFormData.append("ActivityCategory", Cat);
        fetchDocData("Activity/ComboDataAct", bodyFormData);
    }

    const EmployeeData = () => {
        var bodyFormData = new FormData();
        fetchEmployeeData("Activity/ComboDataAct", bodyFormData);
    }

    const handleChange = (event) => {
        setCategory(event.target.value);
        DocType(event.target.value);
    };

    const onCustChange = (event, newValue) => {
        // debugger;
        setCustID(newValue.id);
        setCustName(newValue);
        setAccountID(newValue.id);
        getContactDtls(newValue.id)
        //getRefferenceDtls(newValue.id)
    }

    useEffect(() => {
        if (responseContDtls !== undefined) {
            // debugger;
            if (responseContDtls["cmbContact"] !== undefined) {
                setContactcmb(responseContDtls["cmbContact"]);
            }
        }
    }, [responseContDtls]);

    useEffect(() => {
        if (responseType !== undefined) {
            // debugger;
            if (responseType["cmbActivityType"] !== undefined) {
                setActivitycmb(responseType["cmbActivityType"]);
            }
        }
    }, [responseType]);

    useEffect(() => {
        if (responseDoc !== undefined) {
            // debugger;
            if (responseDoc["cmbDocType"] !== undefined) {
                setDoccmb(responseDoc["cmbDocType"]);
            }
        }
    }, [responseDoc]);

    useEffect(() => {
        if (responseEmployee !== undefined) {
            // debugger;
            if (responseEmployee["SalesExecutive"] !== undefined) {
                setEmployeecmb(responseEmployee["SalesExecutive"]);
            }
        }
    }, [responseEmployee]);

    useEffect(() => {
        CustData();
        TypeData();
        EmployeeData();
        PopulateData('SEARCH');
    }, []);

    const handleOpenModal = () => {
        setActivityID('');
        setUserType(sessionStorage.UserType);
        setOpen(true);
    };

    useEffect(() => {
        // debugger;
        if (responseCust['cmbAccount'] !== undefined && responseCust['cmbAccount'].length > 0) {
            setCustOptions(responseCust['cmbAccount']);
        }
    }, [responseCust['cmbAccount']])

    const PopulateData = (SearchMode) => {
        // debugger;
        var bodyFormData = new FormData();
        setSearchMode(SearchMode);
        var AccName = "";
        if (CustName !== undefined) {
            AccName = CustName.List;
        }
        bodyFormData.append("UserID", sessionStorage.UID);
        bodyFormData.append("UserType", sessionStorage.UserType);
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        bodyFormData.append("CustName", AccName);
        bodyFormData.append("ContactID", ContactID);
        bodyFormData.append("ActivityTypeID", ActivityTypeID);
        bodyFormData.append("ActivityCategory", Category);
        bodyFormData.append("DocumentID", DocumentID);
        bodyFormData.append("EmployeeID", EmployeeID);
        if (FromDate == undefined) {
            bodyFormData.append("FromDate", Moment(Dfromdate).format('YYYY-MM-DD'));
        }
        else {
            bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        }
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        fetchData("Activity/ListView", bodyFormData);

    };

    const openModal = (ID) => {
        setActivityID(ID);
        setUserType(sessionStorage.UserType);
        setOpen(true);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: ".",
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/quotation/QuotationView", state: { QuotationID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.row.id); }} >Edit</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,
            },
            {
                field: "ActivityDate",
                headerName: "Activity Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "Status",
                headerName: "Status",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ActivityStartTime",
                headerName: "Start Time",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 190,
            },
            // {
            //     field: "ActivityEndTime",
            //     headerName: "End Time",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "ActivityType",
            //     headerName: "Activity Type",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "ContactName",
                headerName: "Contact",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "Description",
                headerName: "Description",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },

            {
                field: "Employee",
                headerName: "Employee",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Customer",
                headerName: "Customer",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 240,
            },
            // {
            //     field: "Mobile",
            //     headerName: "Mobile",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "ActivityCategory",
            //     headerName: "DocType",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "DocNo",
            //     headerName: "DocNo",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response, SearchMode]);

    return <div style={{ marginTop: '1%' }}>
        <Grid container="row">
            <Grid xs={2} >
                <div style={{ width: "93%", marginLeft: 6, marginTop: -3 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    >

                    </DatePickerInput>
                </div>
            </Grid>
            <Grid xs={2} >
                <div style={{ width: "93%", marginLeft: 6, marginTop: -3 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    >
                    </DatePickerInput>
                </div>
            </Grid>
            <Grid xs={2} style={{ marginTop: 10 }} >
                <BiztranControls.Select
                    label="Activity Type"
                    id="Type"
                    options={Activitycmb}
                    onChange={(e) => setActivityTypeID(e.target.value)}
                />
            </Grid>
            <Grid xs={2} style={{ marginTop: 10, paddingLeft: 20 }} >
                <BiztranControls.Select
                    label="Employee"
                    id="Type"
                    //width="45ch"
                    options={Employeecmb}
                    onChange={(e) => setEmployyeID(e.target.value)}
                />
            </Grid>
        </Grid>
        <Grid container="row">
            <Grid xs={4} >
                <div style={{ width: "96%", marginLeft: 6, marginTop: -3 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>Customer</label>
                    <BiztranControls.Autocomplete
                        options={CustOptions}
                        onChange={onCustChange}
                        value={CustName}>

                    </BiztranControls.Autocomplete>
                </div>
            </Grid>
            <Grid xs={2} style={{ marginTop: 10 }} >
                <BiztranControls.Select
                    label="Activity Category"
                    id="Category"
                    options={CategoryOption}
                    onChange={handleChange}
                />
            </Grid>
            <Grid xs={2} style={{ marginTop: 10, paddingLeft: 20 }} >
                <BiztranControls.Select
                    label="Document Type"
                    id="Type"
                    options={Documentcmb}
                    onChange={(e) => setDocumentID(e.target.value)}
                />
            </Grid>
        </Grid>
        <Grid container="row">
            <Grid xs={4} >
                <BiztranControls.DropDown
                    label="Contact"
                    //id="Contact"
                    //width="50ch"
                    options={Contactcmb}
                    onChange={(e) => setContactID(e.target.value)}
                />
            </Grid>
            <BiztranControls.Button
                text="SEARCH"
                startIcon={<SearchIcon />}
                onClick={() => {
                    PopulateData('SEARCH');
                }}
            />
            <label style={{ fontWeight: 'bold', marginTop: 16 }}>{Count}</label>
            <BiztranControls.Button
                text="ADD NEW"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => {
                    handleOpenModal();
                }}
            />
        </Grid>
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            pageSize={15}
            rowsPerPageOptions={[15]}
            Height="470px"
            //Height="700px"
            Width="100%"
        />
        <ModalFrame
            title="Activity Details"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateActivities
                setOpen={setOpen}
                ActivityID={ActivityID}
                RefDocumentID={ActivityID}
                UserType={UserType}
                DisableUpdate={false}
                DisableComplete={false}
                DisableDelete={true}
                pageName={"Activities"}
                PopulateData={PopulateData}
                DisableLink="none"
            />
        </ModalFrame>
    </div>;
};

export default Activities;
